import { Button, Drawer, DrawerProps } from 'antd';
import { BaseButtonProps } from 'antd/es/button/button';
import { Footer } from 'antd/es/layout/layout';
import { FC } from 'react';
import styled from 'styled-components';
import { GreenColors, NeutralColors, RedColors } from 'theme';

interface HomeButtonType extends BaseButtonProps {
  active?: boolean;
}

interface MenuButtonType {
  active?: boolean;
}

const FooterLayout = styled(Footer)`
  position: fixed;
  bottom: 0;
  left: 0;
  height: 52px;
  border-top: 1px solid ${NeutralColors[20]};
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1001;
  width: 100vw;

  .fms-btn-text {
    border-radius: 0 !important;
    width: 100%;
    height: 100%;
    padding: 0 !important;
    text-align: center;
    font-size: 10px !important;

    &,
    &:hover,
    &:active {
      background-color: transparent !important;
    }

    svg {
      margin: 0 auto;
      display: block;
      height: 24px;
      width: 24px;
      fill: currentColor;
    }
  }
`;

const HomeButton = styled(Button)<HomeButtonType>`
  color: ${({ active }) =>
    active ? GreenColors[50] : NeutralColors[80]} !important;
  display: flex;
  flex-direction: column;
  gap: 0;
`;

const QuickActionsButton = styled(Button)`
  height: 52px !important;
  width: 52px !important;
  min-width: 52px !important;
  transform: translateY(-11px);
  box-shadow: none;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${NeutralColors[0]} !important;

  svg {
    height: 24px;
    width: 24px;
    fill: currentColor;
  }
`;

const QuickActionsButtonAI = styled(QuickActionsButton)`
  border: 2px solid transparent !important;
  background: linear-gradient(${NeutralColors[0]}) padding-box,
    linear-gradient(
      90deg,
      #1f87dc -17.61%,
      #9154e9 26.22%,
      #9154e9 70.06%,
      #3bb4a6 115.22%
    ) !important;
`;

const MenuButton = styled(Button)<MenuButtonType>`
  color: ${({ active }) =>
    active ? GreenColors[50] : NeutralColors[80]} !important;

  display: flex;
  flex-direction: column;
  gap: 0;
`;

const MenuIconWrapper = styled.span`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
`;

const UnreadBadge = styled.span`
  position: absolute;
  top: -2px;
  right: -2px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: ${RedColors[50]};
`;

const QuickActionsDrawer: FC<DrawerProps> = styled(Drawer)`
  display: flex;
  border-radius: 12px 12px 0 0 !important;

  .fms-drawer-header {
    border: none;
  }

  .fms-drawer-body {
    display: flex;
    flex-wrap: wrap;
    padding: 12px 12px 60px 12px;
  }
`;

export {
  FooterLayout,
  HomeButton,
  MenuButton,
  MenuIconWrapper,
  QuickActionsButton,
  QuickActionsButtonAI,
  QuickActionsDrawer,
  UnreadBadge,
};
